import { HttpClientModule } from '@angular/common/http';
import { APP_ID, InjectionToken, Injector, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouteReuseStrategy } from '@angular/router';
import { ServiceWorkerModule } from '@angular/service-worker';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { IonicConfig } from '@ionic/core';
import { Drivers } from '@ionic/storage';
import { IonicStorageModule, StorageConfig } from '@ionic/storage-angular';

import CordovaSQLiteDriver from 'localforage-cordovasqlitedriver';

import { isCypressTestEnv } from './core/services/environment.service';

import { AppComponent } from './app.component';

import { AppRoutingModule } from './app-routing.module';

import { environment } from '../environments/environment';

import core from './core';
import modals from './modals';
import shared from './shared';

export const APP_SSR_BASE_URL = new InjectionToken<string>('APP_SSR_BASE_URL');
export const APP_SSR_FULL_URL = new InjectionToken<string>('APP_SSR_FULL_URL');

// eslint-disable-next-line no-underscore-dangle
const SQLiteDriver = CordovaSQLiteDriver._driver;

const storageConfig: StorageConfig = isCypressTestEnv()
  ? { driverOrder: [Drivers.LocalStorage] }
  : { driverOrder: [SQLiteDriver, Drivers.IndexedDB, Drivers.LocalStorage] };

const ionicConfig: IonicConfig = {
  mode: 'ios',
  backButtonText: '',
  swipeBackEnabled: false,
  scrollPadding: true,
  scrollAssist: true,
  animated: isCypressTestEnv() ? false : true,
  innerHTMLTemplatesEnabled: true,
};

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    IonicStorageModule.forRoot(storageConfig),
    IonicModule.forRoot(ionicConfig),
    ...core.ssrBrowserModules,
    ...shared,
    ...modals,
    AppRoutingModule,
    HttpClientModule,
    ReactiveFormsModule,
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
  ],
  providers: [
    ...core.providers,
    ...core.ssrBrowserProviders,
    { provide: APP_ID, useValue: 'serverApp' },
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  public static injector: Injector;

  constructor(injector: Injector) {
    AppModule.injector = injector;
  }
}
